import styled from 'styled-components';
import { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Hamburger } from 'ui/icons/navigation/Hamburger';
import { colors } from 'ui/theme/colors';
import { pxToRem } from 'utils/convert';
import { NavButton } from './NavButton';
import { selectNavComponentKey } from '../ducks/selectors';
import { SLIDER_MENUS } from '../constants';
import { closeNav, openNav } from '../ducks/actions';

const sixPx = pxToRem(6);

const StyledHamburger = styled(Hamburger)`
  line {
    transition: transform 100ms ease-in-out;
    transform-origin: center;

    [data-active='true'] & {
      stroke: ${colors.purple100};
    }
  }

  #top-bar {
    transform: translate(0, 0) rotate(0deg);

    [data-active='true'] & {
      transform: translate(-${sixPx}, ${sixPx}) rotate(45deg);
    }
  }

  #middle-bar {
    transform: scale(1);

    [data-active='true'] & {
      transform: scale(0);
    }
  }

  #bottom-bar {
    transform: translate(0, 0) rotate(0deg);

    [data-active='true'] & {
      transform: translate(-${sixPx}, -${sixPx}) rotate(-45deg);
    }
  }
`;

export const MENU_TRIGGER_TEXT = {
  id: 'mobile-menu-trigger',
};

export const HamburgerMenuTrigger = () => {
  const dispatch = useDispatch();
  const navComponentKey = useSelector(selectNavComponentKey);

  const handleClick = (event: SyntheticEvent, navKey?: string) => {
    if (!navKey) return undefined; // When would this ever happen?

    const action = navKey === navComponentKey ? closeNav() : openNav(navKey);
    dispatch(action);
    event.stopPropagation();
  };

  return (
    <NavButton
      id={MENU_TRIGGER_TEXT.id}
      isActive={navComponentKey === SLIDER_MENUS.OPEN_NAVIGATION}
      onClick={(e) => handleClick(e, SLIDER_MENUS.OPEN_NAVIGATION)}
    >
      <StyledHamburger width={20} height={20} />
    </NavButton>
  );
};
